import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Course } from '../models';

@Pipe({
  name: 'withNotRelatedOption',
  standalone: true,
})
export class WithNotRelatedOptionPipe implements PipeTransform {
  #translate: TranslateService = inject(TranslateService);

  transform(value: Course[]): Course[] {
    if (!Array.isArray(value)) {
      return [];
    }

    return [
      {
        id: 0,
        lmsCourseId: null,
        name: this.#translate.instant('courses.notRelatedToCourses'),
      },
      ...value,
    ];
  }
}
